import React, { useReducer, useState, useEffect } from 'react';
import style from '../carriage/CarriageEdit.module.css';
import axios from '../../functions/axios';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import moment from 'moment';
import 'react-widgets/styles.css';
import '../carriage/EditCarriage.css';
import { parseDate } from '../../functions/functions';

function EditCarriage() {
  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };
  const [formData, setFormData] = useReducer(formReducer, {
    carriageDayStop: new Date(),
    carriageDayStart: new Date(), // date string
    routeStart: '', // string
    routeEnd: '', // string
    carrier: '', // number
    contractor: '', // number
    carrierCost: 0, // number
    contractorCost: '', // string
    carrierInvoice: '', // string
    contractorInvoice: '',
    currency: 'EUR', //string
  });
  const [submitting, setSubmitting] = useState(false);
  const [carrier, setCarrier] = useState([]);
  const [contractor, setContractor] = useState([]);
  const { user } = useAuthContext();

  const navigate = useNavigate();
  useEffect(() => {
    if (!user) return null;
    return (() => {
      return Promise.all([getData('/carrier', setCarrier), getData('/contractor', setContractor)]);
    })();
  }, [user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    await axios.post(`/soldCarriage`, formData);
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/soldCarriageList', { state: { date: formData.day } });
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const filterData = (query, data, field) => {
    return
  };

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h2>Wprowadzanie nowego transportu</h2>
          <br />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carrier-data'>
              Nazwa przewoźnika:
            </label>
            <input style={{ width: '432px', marginRight: '10px' }} className={style.weight} id='carrier-data' name='carrier' type='text' onChange={handleChange} value={formData.carrier || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='contractor-data'>
              Nazwa kontrahenta:
            </label>
            <input style={{ width: '432px', marginRight: '10px' }} className={style.weight} id='contractor-data' name='contractor' type='text' onChange={handleChange} value={formData.contractor || ''} />
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='carriageDayStart'>
              Data załadunku
            </label>
            <Localization
                date={new DateLocalizer({
                culture: 'pl-PL',
                firstOfWeek: 1,
              })}
            >
              <DatePicker
                value={new Date(formData.carriageDayStart)}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => handleChange({ target: { name: 'carriageDayStart', value: parseDate(value).day } })}
              />
            </Localization>
            {/* <input type='date' id='day' name='day' onChange={handleChange} value={formData.day || new Date().toISOString()} /> */}
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='carriageDayStop'>
              Data rozładunku
            </label>
            <Localization
                date={new DateLocalizer({
                culture: 'pl-PL',
                firstOfWeek: 1,
              })}
            >
              <DatePicker
                value={new Date(formData.carriageDayStop)}
                valueEditFormat={{ dateStyle: 'long' }}
                valueDisplayFormat={{ dateStyle: 'long' }}
                placeholder='miesiąc/dzień/rok'
                onChange={(value) => handleChange({ target: { name: 'carriageDayStop', value: parseDate(value).day } })}
              />
            </Localization>
            {/* <input type='date' id='day' name='day' onChange={handleChange} value={formData.day || new Date().toISOString()} /> */}
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.category}>Opis trasy</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-start-data'>
              Skąd:
            </label>
            <input style={{ width: '550px', marginRight: '10px' }} id='route-start-data' name='routeStart' type='text' onChange={handleChange} value={formData.routeStart  || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-end-data'>
              Dokąd:
            </label>
            <input style={{ width: '550px', marginRight: '10px' }} id='route-end-data' name='routeEnd' type='text' onChange={handleChange} value={formData.routeEnd || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carrierCost-data'>
              Stawka przewoźnika:
            </label>
            <input type='number' min='0' step='any' id='carrierCost-data' name='carrierCost' onChange={handleChange} checked={formData.carrierCost ?? 0} /> </div>
            <div className={style.row}>
            <label className={style.subcategory} htmlFor='cost-data'>
              Stawka nasza:
            </label>
            <input type='number' min='0' step='any' id='contractorCost-data' name='contractorCost' onChange={handleChange} checked={formData.contractorCost ?? 0} />    </div>
            <div className={style.row}>  
            <label className={style.subcategory} htmlFor='currency-data'>
              Waluta:
            </label>                
            <select name='currency' id='currency' defaultValue='EUR' onChange={handleChange}>
              <option value='EUR'>EURO €</option>
              <option value='PLN'>PLN zł</option>
            </select>
          </div>
        </div>
        <hr />
        <div className={style.section}>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='carrierInvoice-data'>
              Nr faktury przewoźnika
            </label>
            <input style={{ width: '200px', marginRight: '10px' }} id='carrierInvoice-data' name='carrierInvoice' type='text' onChange={handleChange} value={formData.carrierInvoice || ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='contractorInvoice-data'>
              Nr faktury nasz
            </label>
            <input style={{ width: '200px', marginRight: '10px' }} id='contractorInvoice-data' name='contractorInvoice' type='text' onChange={handleChange} value={formData.contractorInvoice || ''} />
          </div>
          <hr />
          <span className={style.buttons}>
            <button className='btn btn-default' onClick={navigate.bind(null, '/soldCarriageList', { state: { date: formData.day } })}>
              Anuluj
            </button>
            <button className='btn btn-default' type='submit'>
              Zapisz
            </button>
          </span>
        </div>
      </form>
    </div>
  );
}

const getData = async (path, callback) => {
  try {
    const { data: response } = await axios.get(path) || [];
    response.sort((...args) => {
      const [a, b] = args.map(({ carrier, contractor}) => carrier || contractor);
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
    callback(response);
  } catch (error) {
    console.error(error.message);
  }
};

export default EditCarriage;
